<template>
  <div>
    <dialog-loading loadingText="Salvando" v-if="saving"></dialog-loading>
    <v-dialog v-model="dialog" persistent fullscreen hide-overlay transition="dialog-bottom-transition">
      <v-card>
        <v-toolbar dark color="blue-grey">
          <v-btn icon dark @click.native="$router.push({name: 'ClientPortfolios'})"><v-icon>mdi-close</v-icon></v-btn>
          <v-toolbar-title>Detalhes da Carteira de Clientes</v-toolbar-title>
        </v-toolbar>
        <v-card-text v-if="!loading">
          <v-container>
            <v-expansion-panels multiple v-model="panel" flat active-class="elevation-4" :readonly="editing">
              <v-expansion-panel  style="border-bottom: solid #ddd 1px;" ripple>
                <v-expansion-panel-header class="red--text font-weight-bold">
                  <div>
                    <v-icon size="19" color="red">mdi-information</v-icon>
                    Informações básicas
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-container grid-list-xl>
                    <v-row justify="space-around">
                      <template v-if="canEditClientPortfolio && client_portfolio?.attributes?.activity_level == 'not_applicable'">
                        <v-col cols='12' class="d-flex justify-end">
                          <f-btn edit small class="ml-2" @click="startEditing('info')" v-if="!edit.info" :disabled="editing" ></f-btn>
                          <f-btn cancel small class="ml-2" @click="cancelEditing('info')" v-if="edit.info"></f-btn>
                          <f-btn save small class="ml-2" @click="submitChanges('info')" v-if="edit.info"></f-btn>
                        </v-col>
                        <v-spacer></v-spacer>

                      </template>
                      <ClientsPortfolioInfoForm ref="info" :readonly="!edit.info" :client_portfolio="client_portfolio.attributes"></ClientsPortfolioInfoForm>
                    </v-row>
                  </v-container>
                </v-expansion-panel-content>
              </v-expansion-panel>

              <v-expansion-panel  style="border-bottom: solid #ddd 1px;" ripple>
                <v-expansion-panel-header class="red--text font-weight-bold">
                  <div>
                    <v-icon size="19" color="red">mdi-account-multiple</v-icon>
                    Clientes da carteira
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-container grid-list-xl>
                    <v-row justify="space-around">
                      <template>
                        <v-col cols='12' class="d-flex justify-end">
                          <BtnCreateDataExport 
                            class="mx-3"
                            light-toolbar
                            api_model="ClientPortfolio" 
                            action="ClientPortfolios"
                            small
                            :filters="{id: $route.params.id}"
                            :file_name="client_portfolio.attributes.name"
                          ></BtnCreateDataExport>
                          <f-btn edit small class="ml-2" @click="startEditing('clients')" v-if="!edit.clients && canEditClientPortfolio && client_portfolio?.attributes?.activity_level == 'not_applicable'" :disabled="editing"></f-btn>
                          <f-btn cancel small class="ml-2" @click="cancelEditing('clients')" v-if="edit.clients"></f-btn>
                          <f-btn save small class="ml-2" @click="submitChanges('clients')" v-if="edit.clients"></f-btn>
                        </v-col>
                        <v-spacer></v-spacer>
                      </template>
                      <ClientPortfolioSelectClients ref="clients" :set_clients="!edit.clients" :readonly="!edit.clients" :client_portfolio="client_portfolio.attributes"></ClientPortfolioSelectClients>
                    </v-row>
                  </v-container>
                </v-expansion-panel-content>
              </v-expansion-panel>

              <v-expansion-panel  style="border-bottom: solid #ddd 1px;" ripple>
                <v-expansion-panel-header class="red--text font-weight-bold">
                  <div>
                    <v-icon size="19" color="red">mdi-clipboard-account</v-icon>
                    Funcionários da carteira
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-container grid-list-xl>
                    <v-row justify="space-around">
                      <template v-if="canEditClientPortfolio">
                        <v-col cols='12' class="d-flex justify-end">
                          <f-btn edit small class="ml-2" @click="startEditing('employees')" v-if="!edit.employees" :disabled="editing"></f-btn>
                          <f-btn cancel small class="ml-2" @click="cancelEditing('employees')" v-if="edit.employees"></f-btn>
                          <f-btn save small class="ml-2" @click="submitChanges('employees')" v-if="edit.employees"></f-btn>
                        </v-col>
                        <v-spacer></v-spacer>
                      </template>
                      <ClientPortfolioSelectEmployees ref="employees" :readonly="!edit.employees" :client_portfolio="client_portfolio.attributes"></ClientPortfolioSelectEmployees>
                    </v-row>
                  </v-container>
                </v-expansion-panel-content>
              </v-expansion-panel>

              <v-expansion-panel  style="border-bottom: solid #ddd 1px;" ripple v-if="canEditClientPortfolio && client_portfolio?.attributes?.activity_level == 'not_applicable'">
                <v-expansion-panel-header class="red--text font-weight-bold">
                  <div>
                    <v-icon size="19" color="red">mdi-cog</v-icon>
                    {{status_map[client_portfolio.attributes.status].action}} carteira de clientes
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-container grid-list-xl>
                    <v-row justify="space-around">
                      <v-col cols="12">
                        <v-btn @click="changeStatus" :color="status_map[client_portfolio.attributes.status].action_color">
                          <v-icon left>{{status_map[client_portfolio.attributes.status].action_icon}}</v-icon>
                          {{status_map[client_portfolio.attributes.status].action}} Carteira de Clientes
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-expansion-panel-content>
              </v-expansion-panel>
        
            </v-expansion-panels>
          </v-container>
        </v-card-text>
        <card-loading-transparent v-if="loading" class="pt-5"></card-loading-transparent>
      </v-card>
    </v-dialog>
  </div>
</template>


<script>
import { mapActions } from 'vuex';
import Api from '@/api/index'

export default {
  name: 'ShowClientPortfolio',
  components: { 
    ClientsPortfolioInfoForm: () => import("@/_backoffice/_registrations/components/client_portfolio/forms/ClientsPortfolioInfoForm.vue"),
    ClientPortfolioSelectClients: () => import("@/_backoffice/_registrations/components/client_portfolio/forms/ClientPortfolioSelectClients.vue"),
    ClientPortfolioSelectEmployees: () => import("@/_backoffice/_registrations/components/client_portfolio/forms/ClientPortfolioSelectEmployees.vue"),
    BtnCreateDataExport: () => import('@/components/data_export/BtnCreateDataExport.vue'),
  },
  data() {
    return {
      dialog: true,
      loading: true,
      saving: false,
      panel: [0],
      edit:{
        info: false,
        clients: false,
        employees: false,
      },
      client_portfolio: {
        id: null,
        attributes: {
          name: "",
          status: 0,
          kind: 0,
          client_ids:[],
          employee_ids:[],
          module_ids:[],
        }
      },
      client_portfolio_aux: {},
      status_map:{
        "active": {
          text: "Ativo",
          action: "Desativar",
          action_icon: "mdi-cancel",
          action_color: "error",
          action_filter: { status: 'disabled' },
        },
        "disabled": {
          text: "Desativado",
          action: "Ativar",
          action_icon: "mdi-keyboard-return",
          action_color: "success",
          action_filter: { status: 'active' },
        },
      }
    }
  },
  computed:{
    editing(){
      return this.edit.info || this.edit.clients || this.edit.employees
    },
    canEditClientPortfolio(){
      return (this.isDirector() || this.isSalesExecutive() || this.isManager() || this.isFinancial())
    },
  },
  methods: {
    getData(){
      this.getClientPortfolio();
      this.setOpenExpansionPanels()
    },
    setOpenExpansionPanels(){
      let params = this.$route.params
      if(params.edit_clients){
        this.panel = [1]
      }else if(params.edit_employees){
        this.panel = [2]
      }
    },
    prepareClientPortfolio(kind){
      let new_client_portfolio = { id: this.client_portfolio.id }
      if(kind == 'info'){
        new_client_portfolio.name = this.client_portfolio.attributes.name
        new_client_portfolio.kind = this.client_portfolio.attributes.kind
        new_client_portfolio.module_ids = this.client_portfolio.attributes.module_ids
      }else if(kind == 'employees'){
        new_client_portfolio.employee_ids = this.client_portfolio.attributes.employee_ids
      }else if(kind == 'clients'){
        new_client_portfolio.client_ids = this.client_portfolio.attributes.client_ids
      }
      return new_client_portfolio
    },
    submitChanges(kind){
      if(this.$refs[kind].validate()){
        this.saving = true
        let client_portfolio = this.prepareClientPortfolio(kind)
        Api.ClientPortfolio.update(client_portfolio).then(()=>{
          this.successUpdated()
          this.cancelEditing(kind, false)
        }).catch((err)=>{
          this.addNotification({type: 'error',  msg: err})
        }).finally(()=>{
          this.saving = false
        })
      }else{
        this.addNotification({type: 'error',  msg: `Alguns campos não foram preenchidos.`})
      }
    },
    getClientPortfolio(){
      this.loading = true
      Api.ClientPortfolio.show(this.$route.params.id).then(r=>r.data).then(r => {
        this.client_portfolio = {...r.data}
      }).catch(err=>{
        console.log(err)
      }).finally(() => {
        this.loading = false
      })
    },
    changeStatus(){
      this.swallConfirmation({
          title: 'Deseja atualizar status?',
          icon: 'question',
        }).then( confirmed =>{
          if (confirmed ) {
            let updated_client_portfolio = {}
            updated_client_portfolio = this.status_map[this.client_portfolio.attributes.status].action_filter
            updated_client_portfolio.id = this.client_portfolio.id
            this.saving = true
            Api.ClientPortfolio.update(updated_client_portfolio).then(()=>{
              this.successUpdated()
              this.$emit("statusChanged")
              this.getData()
            }).finally(()=>{
              this.saving = false
            })
          }
        })
    },
    startEditing(kind){
      this.client_portfolio_aux = JSON.parse(JSON.stringify(this.client_portfolio))
      this.edit[kind] = true
    },
    cancelEditing(kind, restore_item = true){
      this.edit[kind] = false
      if(restore_item){
        this.client_portfolio = {...this.client_portfolio_aux}
      }
    },
    ...mapActions({
      addNotification: 'Notification/add'
    })
  },
  mounted () {
    this.getData()
  },
}
</script>
